import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {DayPicker} from 'react-day-picker';
import moment from 'moment';
import Modal from 'react-bootstrap/lib/Modal';
import useLocalizationLoadFile from 'helpers/hooks/useLocalizationLoadFile';
import {formatDateShort} from 'lib/helpers/globalize-helper';

const DatePickerWrapper = ({isMobile, obDate, ibDate, roundTrip, setDate, setDates, tripIndex,
  cssClass, disableBefore}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [chosenObDate, setChosenObDate] = useState(false);
  const dayPickerLocale = useLocalizationLoadFile();

  const handleDateClick = (obj, date) => {
    if (roundTrip) {
      if (moment(date).isBefore(moment(obDate)) || !chosenObDate) {
        setDates({fromDate: date, toDate: date}, tripIndex);
        setChosenObDate(true);
      } else {
        toggleDatePicker();
        setChosenObDate(false);
        setDate('ibDate', date, tripIndex);
      }
    } else {
      setDates({fromDate: date, toDate: date}, tripIndex);
      toggleDatePicker();
    }
  };

  const toggleDatePicker = () => setShowDatePicker((showDatePicker) => !showDatePicker);

  const dateOptions = () => {
    const selectedDays = roundTrip ? [obDate, {from: obDate, to: ibDate}] : obDate;

    return (
      <div className="d-flex align-items-center justify-content-center">
        <DayPicker
          mode="range"
          numberOfMonths={isMobile ? 1 : 2}
          selected={selectedDays}
          fromDate={disableBefore && disableBefore instanceof Date ? disableBefore : moment().toDate()}
          toDate={moment().add(1, 'years').toDate()}
          locale={dayPickerLocale}
          onSelect={handleDateClick}
          defaultMonth={obDate}
        />
      </div>
    );
  };

  const displayObDate = formatDateShort(moment(obDate));
  const displayIbDate = formatDateShort(moment(ibDate));
  const displayValues = roundTrip ? `${displayObDate} - ${displayIbDate}` : displayObDate;

  return (
    <div className={`grid-item mb-2 ${cssClass}`}>
      <div className="form-control rounded-0 input-icon input-icon-flip pr-6">
        <div className="text-truncate" onClick={toggleDatePicker}>
          {displayValues}
        </div>
        <span onClick={toggleDatePicker} className="icon icon-calendar-2" aria-hidden="true"></span>
        <Modal
          show={showDatePicker}
          onHide={toggleDatePicker}
        >
          {dateOptions()}
        </Modal>
      </div>
    </div>
  );
};

DatePickerWrapper.defaultProps = {
  roundTrip: false
};

DatePickerWrapper.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  obDate: PropTypes.object.isRequired,
  ibDate: PropTypes.object.isRequired,
  setDate: PropTypes.func.isRequired,
  setDates: PropTypes.func.isRequired,
  roundTrip: PropTypes.bool.isRequired,
  tripIndex: PropTypes.number,
  cssClass: PropTypes.string,
  disableBefore: PropTypes.object
};

export default observer(DatePickerWrapper);
